class MFooter extends HTMLElement {
  constructor() {
    super();
    this.mobileMedia = window.matchMedia("(max-width: 767px)");
    this.handleClick = this.handleClick.bind(this);
    this.handleViewportChange = this.handleViewportChange.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleBlockSelect = this.handleBlockSelect.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.handleClick);
    this.mobileMedia.addEventListener?.("change", this.handleViewportChange);
    window.addEventListener("resize", this.handleResize, { passive: true });
    this.addEventListener("shopify:block:select", this.handleBlockSelect);
    this.prepareAccordion();
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
    this.mobileMedia.removeEventListener?.("change", this.handleViewportChange);
    window.removeEventListener("resize", this.handleResize);
    this.removeEventListener("shopify:block:select", this.handleBlockSelect);
  }

  get mode() {
    return this.dataset.mobileAccordion || "accordion";
  }

  get singleOpen() {
    return this.dataset.singleOpen !== "false";
  }

  prepareAccordion() {
    const isMobile = this.mobileMedia.matches;

    this.querySelectorAll(".m-footer--block").forEach((block) => {
      const button = block.querySelector(".tanatel-footer__accordion-button");
      const content = block.querySelector(".tanatel-footer__accordion-content");
      if (!button || !content) return;

      if (!isMobile || this.mode === "expanded") {
        block.classList.add("open");
        button.setAttribute("aria-expanded", "true");
        button.setAttribute("aria-disabled", "true");
        button.tabIndex = -1;
        content.style.removeProperty("--tanatel-footer-content-height");
        return;
      }

      block.classList.remove("open");
      button.removeAttribute("aria-disabled");
      button.tabIndex = 0;
      button.setAttribute("aria-expanded", "false");
      this.setContentHeight(content);
    });
  }

  handleClick(event) {
    const button = event.target.closest(".tanatel-footer__accordion-button");
    if (
      !button ||
      !this.mobileMedia.matches ||
      this.mode === "expanded"
    ) {
      return;
    }

    const block = button.closest(".m-footer--block");
    const content = block?.querySelector(".tanatel-footer__accordion-content");
    if (!block || !content) return;

    const willOpen = !block.classList.contains("open");
    if (willOpen && this.singleOpen) {
      this.querySelectorAll(".m-footer--block.open").forEach((openBlock) => {
        if (openBlock === block) return;

        openBlock.classList.remove("open");
        openBlock
          .querySelector(".tanatel-footer__accordion-button")
          ?.setAttribute("aria-expanded", "false");
      });
    }
    this.setContentHeight(content);
    block.classList.toggle("open", willOpen);
    button.setAttribute("aria-expanded", String(willOpen));
  }

  setContentHeight(content) {
    content.style.setProperty(
      "--tanatel-footer-content-height",
      `${content.scrollHeight + 24}px`
    );
  }

  handleViewportChange() {
    this.prepareAccordion();
  }

  handleResize() {
    if (this.mobileMedia.matches && this.mode !== "expanded") {
      this.querySelectorAll(".tanatel-footer__accordion-content").forEach(
        (content) => this.setContentHeight(content)
      );
    }
  }

  handleBlockSelect(event) {
    if (!this.mobileMedia.matches || this.mode === "expanded") return;

    const block = event.target.closest(".m-footer--block");
    const button = block?.querySelector(".tanatel-footer__accordion-button");
    const content = block?.querySelector(".tanatel-footer__accordion-content");
    if (!block || !button || !content) return;

    this.setContentHeight(content);
    block.classList.add("open");
    button.setAttribute("aria-expanded", "true");
  }

}

if (!customElements.get("m-footer")) {
  customElements.define("m-footer", MFooter);
}
